export class Assets {
    constructor() {
        this._textures = {
            hatchA: null,
            hatchB: null,
            hatchC: null,
            hatchD: null,
            noise: null,
        },

        this._model = null

    }

    setTexture({ key, texture }) {
        this._textures = {
            ...this._textures,
            [key]: texture
        }
    }

    get textures() {
        return this._textures;
    }

    set model(m) {
        this._model = m
    }

    get model() {
        return this._model;
    }
}